import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import H3 from '../components/typography/headers/H3'
import JustifyCenter from '../components/presentational/JustifyCenter'
import TextButton from '../components/typography/buttons/TextButton'
import AuthWrapper from '../components/auth/AuthWrapper'

import { unlockAccount } from '../actions/unlockaccount'

class UnlockAccount extends Component {
  constructor(props) {
    super(props)

    this.onReturnToLoginClickBound = this.onReturnToLoginClick.bind(this)

    window.scrollTo(0, 0)
  }

  componentDidMount() {
    this.props.dispatch(unlockAccount(this.props.params.token))
  }

  render() {
    const { success, unlockErrorStatusText } = this.props
    return (
      <AuthWrapper>
        <React.Fragment>
          <JustifyCenter>
            {success && (
              <H3 style={{ marginBottom: '35px' }}>Account Unlocked!</H3>
            )}
          </JustifyCenter>
          <p
            style={{ margin: '30px 0', fontSize: '16px', textAlign: 'center' }}
            className="unlock-account-message"
          >
            {success
              ? 'You can now use your username and password to login.'
              : unlockErrorStatusText}
          </p>
          <TextButton
            style={{ marginTop: 'auto', paddingBottom: '60px' }}
            onClick={this.onReturnToLoginClickBound}
            fontSize="13px"
          >
            Return to Login
          </TextButton>
        </React.Fragment>
      </AuthWrapper>
    )
  }
  onReturnToLoginClick() {
    this.props.dispatch(push('/login'))
  }
}

export const mapStateToProps = state => ({
  unlockErrorStatusText: state.unlockaccount.unlockErrorStatusText,
  failure: state.unlockaccount.failure,
  success: state.unlockaccount.success
})

UnlockAccount.propTypes = {
  dispatch: PropTypes.func,
  params: PropTypes.object,
  unlockErrorStatusText: PropTypes.string,
  failure: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired
}

export default connect(mapStateToProps)(UnlockAccount)
export { UnlockAccount as UnlockAccountDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/UnlockAccount.js